import { createApi } from '@reduxjs/toolkit/query/react';
import baseApi from './base';
import { setBreadcrumbs } from 'slices/config';
import paginationParams from 'utils/pagination-params';

export const list = 'LIST_VIDEO_QUESTION_TEST_RESULTS';
export const single = 'SINGLE_VIDEO_QUESTION_TEST_RESULT';

export const videoQuestionTestResultsApi = createApi({
  reducerPath: 'videoQuestionTestResultsApi',
  baseQuery: baseApi,
  tagTypes: [list, single],
  endpoints: (builder) => ({
    createVideoQuestionTestResult: builder.mutation({
      query: (body) => ({
        url: '/video-question-test-results/create',
        method: 'POST',
        body
      }),
      invalidatesTags: [list]
    }),
    submitVideoQuestionTestResult: builder.mutation({
      query: ({ id, ...attributes }) => ({
        url: `/video-question-test-results/submit/${id}`,
        method: 'PUT',
        body: { ...attributes }
      }),
      invalidatesTags: [single]
    }),
    getVideoQuestionTestResultById: builder.query({
      query: ({ id, archived }) => ({ url: `/video-question-test-results/view/${id}`, ...(archived && { params: { archived: 1 } }) }),
      providesTags: [single],
      async onQueryStarted(_, { dispatch, getState, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (getState().auth?.isLoggedIn && data?.data?.status === 'evaluated') {
            dispatch(setBreadcrumbs(`${data?.data?.email}/${data?.data?.referenceName ?? 'N/A'}`));
          }
        } catch (err) {
          console.error('Error updating cache:', err);
        }
      }
    }),
    unarchiveVideoQuestionTestResult: builder.mutation({
      query: (ids) => ({
        url: `/video-question-test-results/unarchive`,
        method: 'POST',
        body: {
          ids
        }
      }),
      async onQueryStarted(ids, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(
            resumeProfileTestResultsApi.util.updateQueryData('listVideoQuestionTestResults', undefined, (draft) => {
              draft.data.items = draft.data.items.filter((item) => !ids.includes(item.id));
            })
          );
        } catch (err) {
          console.error('Error updating cache:', err);
        }
      }
    }),
    listVideoQuestionTestResults: builder.query({
      query: (params) => ({
        url: '/video-question-test-results/list',
        params
      }),
      providesTags: [list],
      ...paginationParams
    }),
    exportVideoQuestionTestResults: builder.query({
      query: (params) => ({
        url: '/video-question-test-results/export',
        params: { ...params },
        responseHandler: (response) => response.text()
      })
    })
  })
});

export const {
  useCreateVideoQuestionTestResultMutation,
  useSubmitVideoQuestionTestResultMutation,
  useUnarchiveVideoQuestionTestResultMutation,
  useGetVideoQuestionTestResultByIdQuery,
  useListVideoQuestionTestResultsQuery,
  useExportVideoQuestionTestResultsQuery,
  useLazyExportVideoQuestionTestResultsQuery
} = videoQuestionTestResultsApi;
